import './thehotchkisschool/style';
import FormStructure from './thehotchkisschool/form_structure';

export default FormStructure;